export default "__VITE_ASSET__c41b3a84__"